/**
 * repository pattern plugin
 * See - https://morioh.com/p/3101f1df2939
 */

import createRepository from '~/api/repository'

export default (ctx, inject) => {
  // inject the repository in the context (ctx.app.$redis)
  // And in the Vue instances (this.$redis in your components)

  const newRepository = createRepository(ctx.$axios)

  /**
   * Redis client api - the serverMiddleware
   */
  const repositories = {
    cities: newRepository('/redis/cache/cities/'),
    experience: newRepository('/redis/cache/experience/'),
    range: newRepository('/redis/cache/range/'),
    drushimhitech: newRepository('/redis/cache/drushimhitech/'),
    home: newRepository('/redis/cache/home/'),
    footer: newRepository('/redis/cache/footer/'),

    activejobslisting: newRepository('/redis/cache/activejobslisting/'),
    benefit: newRepository('/redis/cache/benefit/'),
    categories: newRepository('/redis/cache/categories/'),
    zones: newRepository('/redis/cache/zones/'),
    regions: newRepository('/redis/cache/regions/')
    //...
  }

  inject('redis', repositories)

  // You can reuse the repositoryWithAxios object:
  // inject("userRepository", repositoryWithAxios('/users'));
}
